import { render, staticRenderFns } from "./FrequentQuestionsDrawer.vue?vue&type=template&id=5270e998"
import script from "./FrequentQuestionsDrawer.vue?vue&type=script&lang=js"
export * from "./FrequentQuestionsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports